<template>
  <div>
    <v-card class="mx-auto" width="96%" style="margin-top: 20px;">
      <v-container fluid>
        <v-row>
          <v-col col="12">
            <iframe v-if="host === 'predixon.noisegrasp.com' || oidParam === 'publicis'" src="https://noisegrasp.gitbook.io/predixon-documentation" width="100%" style="height:70vh;"></iframe>
            <iframe v-else src="https://noisegrasp.gitbook.io/ng_documentation" width="100%" style="height:70vh;"></iframe>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('auth', [
      'authUser'
    ]),
    ...mapGetters('clients', [
      'currentClientObject'
    ]),
    oidParam () {
      return (new URLSearchParams(window.location.search).get('oid'))
    },
    host () {
      return window.location.hostname
    },
    skin () {
      // Duplicated in App.vue
      // TODO: Unify
      if (window.location.hostname === 'predixon.noisegrasp.com') {
        return {
          name: 'Predixon'
        }
      } else if (window.location.hostname === 'outflink.noisegrasp.com') {
        return {
          name: 'Outflink'
        }
      } else if (window.location.hostname === 'deloitte.noisegrasp.com') {
        return {
          name: 'Deloitte Marketing Mix Modeling'
        }
      } else if (window.location.hostname === 'nisum.noisegrasp.com') {
        return {
          name: 'Nisum Marketing Mix Modeling'
        }
      } else if (window.location.hostname === 'mckinsey.noisegrasp.com') {
        return {
          name: 'McKinsey Marketing Mix Modeling'
        }
      } else if (window.location.hostname === 'comscore.noisegrasp.com') {
        return {
          name: 'Comscore Marketing Mix Modeling'
        }
      } else {
        return {
          name: 'NoiseGrasp'
        }
      }
    }
  },
  components: {}
}
</script>
